module.exports = __webpack_public_path__ + "fdab1bde6111a4cdad40cb1a29b696dc.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/login/img/premio-br-week-pt.png
// module id = 1241
// module chunks = 0